<template>
  <b-container class="mt-2 d-print-none mb-3 text-center d-print-none">
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12 text-center">
        <router-link :to="{ name: 'Home' }">
          <b-navbar-brand>
            <b-img
                :src="findAttributeOnSiteInfo('icon')[0]"
                height="130"
            />
          </b-navbar-brand>
        </router-link>
      </div>
      <div class="col-lg-6 col-md-6">
        <form class="form2">
          <a class="button-Search bg-primary " @click="searchProduct">
            <b-icon class="text-light " icon="search "></b-icon>
          </a>
          <input
              class="input-search "
              type="text"
              placeholder="جستجو..."
              name="search"
              @keydown.enter.prevent="searchProduct"
              v-model="words"
          />
        </form>
      </div>
      <div class="col-lg-3 col-md-3 icons-styles ">
        <span v-if="$store.getters['User/isAuthenticated']"
        ><router-link :to="{ name: 'Dashboard' }"
        ><b-icon class="login-icon" icon="person " href="#"> </b-icon></router-link
        ></span>

        <span v-else
        ><router-link :to="{ name: 'Login' }" class="login-icon"
        ><b-icon class="login-icon" icon="person" href="#"> </b-icon></router-link
        ></span>

        <span v-if="IsAuthenticated || findAttributeOnSiteInfo('cartType') == 1">
          <span class="badge badge-warning shopping-cart-counter "
                v-if=" orderCount.length != 0 && orderCount.items != undefined">{{ orderCount.items.length }} </span>
          <router-link :to="{ name: 'ShoppingCart' }">
            <b-icon class="login-icon" icon="cart-fill" href="#"></b-icon>
          </router-link>

        </span>
        <span v-else>
          <span
              class="badge badge-warning shopping-cart-counter "> {{
              shoppingCartCount
            }}  </span>
          <router-link :to="{ name: 'UnAuthenticatedShoppingCart' }">
            <b-icon class="login-icon" icon="cart-fill" href="#"></b-icon>
          </router-link>
        </span>

      </div>
    </div>
  </b-container>
</template>

<script>
import {mapGetters} from 'vuex';
import axios from "axios";

export default {
  name: "Nav2",
  data() {
    return {
      searchWord: '',
      shoppingCartCount: 0
    }
  },
  methods: {
    searchProduct() {
      const query = Object.assign({}, this.$router.currentRoute.query);
      console.log(this.searchWord)
      if (this.searchWord !== "") {
        this.$router.push({
          name: "Products",
          query: {...this.$router.currentRoute.query, search: this.searchWord},
        });
      } else {
        this.$router.push({
          name: "Products",
          query: '',
        });
      }
    },
    countItemsOnUnAuthenticatedShoppingCart() {
      const localProducts = localStorage.products;
      this.shoppingCartCount = localProducts != undefined ? Object.keys(JSON.parse(localStorage.products)).length : 0;
    }
  },
  computed: {
    words: {
      get() {
        return this.searchWord;
      },
      set(searchedWord) {
        this.searchWord = searchedWord
      },
    },
    ...mapGetters({
      'orderCount': 'ShoppingCart/getSidebarBasketData',
    }),

    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },
    getBaseUrl() {
      return axios.defaults.baseURL.replace('api', '')
    },

  },
  async mounted() {
    const search = this.$router.currentRoute.query.search;
    if (search != undefined) {
      this.searchWord = search;
      // this.$store.dispatch("Product/filteredProducts", search);
    }

    if (this.IsAuthenticated) {
      await this.$store.dispatch("ShoppingCart/userOrderUnpaid");
    }

    window.addEventListener('click', this.countItemsOnUnAuthenticatedShoppingCart);

  },
};
</script>

<style scoped>

.photo-nav {
  width: 70px;
  margin-left: auto;
  margin-right: auto;
}

.form2 {
  position: relative;
}

.form2 input {
  width: 100%;
  border: 1px solid var(--light-primary) !important;
  padding: 10px 15px;
  border-radius: 200px;
  box-shadow: 0 1px 6px var(--light-cyan) !important;
}


.form2 .button-Search {
  position: absolute;
  left: 0;
  background-color: var(--primary) !important;
  color: var(--light) !important;
  padding: 8px 25px;
  border-radius: 200px;
  cursor: pointer;
  height: 100%;
}

.form2 .button-Search:hover {
  background: var(--primary) !important;
}


.input-search {
  font-size: 0.8rem;
  text-align: right;
}

.login-icon {
  color: var(--primary) !important;
}

.badge {
  padding-left: 9px;
  padding-right: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
}

.shopping-cart-counter {
  font-size: 12px;
  background: var(--secondary) !important;
  color: var(--light-cyan);
  padding: 0 5px;
  vertical-align: top;
  margin-left: -15px;
  margin-top: 5px;
}

.icons-styles {
  color: var(--primery) !important;
  font-size: 25px;
}

.router-link-active {
  color: var(--primary);
}

.navbar-brand img {
  height: 45px;
}
</style>